// Row color classes
export const ROW_COLORS = {
  sales: 'bg-blue-50 text-blue-900',
  gross: 'bg-green-50 text-green-900',
  fiIncome: 'bg-green-50 text-green-900',
  totalGross: 'bg-green-100 text-green-900',
  variableExpense: 'bg-orange-50 text-orange-900',
  semiFixedExpense: 'bg-amber-50 text-amber-900',
  salesExpense: 'bg-yellow-50 text-yellow-900',
  fixedExpense: 'bg-purple-50 text-purple-900',
  otherExpense: 'bg-gray-100 text-gray-900',
  totalExpense: 'bg-red-50 text-red-900',
  profit: 'bg-emerald-100 text-emerald-900',
  loss: 'bg-red-100 text-red-900',
  rentalIncome: 'bg-teal-50 text-teal-900',
  rentalExpense: 'bg-orange-50 text-orange-900',
  clearing: 'bg-gray-50 text-gray-900',
  totalMisc: 'bg-gray-200 text-gray-900',
};

// Map category names to colors
export const CATEGORY_COLORS: Record<string, string> = {
  'VARIABLE': ROW_COLORS.variableExpense,
  'SEMI_FIXED': ROW_COLORS.semiFixedExpense,
  'SALES': ROW_COLORS.salesExpense,
  'FIXED': ROW_COLORS.fixedExpense,
  'OTHERS': ROW_COLORS.otherExpense,
  'RENTAL_INCOME': ROW_COLORS.rentalIncome,
  'RENTAL_SELLING': ROW_COLORS.variableExpense,
  'RENTAL_FIXED': ROW_COLORS.fixedExpense,
  'CLEARING': ROW_COLORS.clearing,
};

/**
 * Income category names - credits in these categories should display as positive
 */
export const INCOME_CATEGORIES = ['RENTAL_INCOME', 'OTHER_INCOME'];
